import React from 'react';
import { useParams } from "react-router-dom";
import { useHistory } from 'react-router';
import Referral from './Referral';

const ReferralContainer = () => {
  const history = useHistory();
  const { clinicId, buildingId } = useParams();

  const hanleSelectIsReferral = (isReferral) => {
    history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/service/${clinicId}/${buildingId}/${isReferral ? '1' : '0'}`);
  }
  return (
    <Referral
      hanleSelectIsReferral={hanleSelectIsReferral}
    />
  )
}

export default ReferralContainer;
